import { Fragment, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { useAtom } from 'jotai';
import { notificationAtom, NotificationType } from '../atoms/system';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import _ from 'lodash';

const Notification = (): JSX.Element => {
  const [payload, setPayload] = useAtom(notificationAtom);
  useEffect(() => {
    if (payload.show) {
      setTimeout(() => {
        setPayload({
          show: false,
          type: null,
          title: null,
        });
      }, 6000);
    }
  }, [payload.show]);

  return (
    <Transition
      show={payload.show}
      as={Fragment}
      enter="transform ease-out duration-300 transition"
      enterFrom="-translate-y-2 opacity-0"
      enterTo="translate-y-0 opacity-100"
      leave="transition ease-in duration-100"
      leaveFrom="translate-y-0 opacity-100"
      leaveTo="translate-y-2 opacity-0"
    >
      <div
        className={clsx(
          payload.type === NotificationType.success
            ? 'bg-green-100'
            : 'bg-red-100',
          'fixed z-[9999] w-80 bottom-16 lg:bottom-10 left-1/2 -translate-x-1/2 shadow-lg rounded-lg pointer-events-none',
        )}
      >
        <div className="w-full p-4 flex items-center justify-center">
          <div className="flex-shrink-0">
            {payload.type === NotificationType.success ? (
              <CheckCircleIcon className="h-6 w-6 text-green-500" />
            ) : (
              <XCircleIcon className="h-6 w-6 text-red-500" />
            )}
          </div>
          <div className="ml-3 w-0 flex-1 pt-0.5">
            <p className="text-sm font-medium text-gray-900">
              {_.isNull(payload.title) ? 'Đã có lỗi xảy ra' : payload.title}
            </p>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default Notification;
